import React from 'react';
import { cn } from '@/utils/cn';
import Icon from '../Icon';

function View3D({ children, className = '', disabled = false, ...rest }) {
  return (
    <button
      type="button"
      aria-label="View 3D Model"
      className={cn(
        'view-3D-button px-12 py-4 rounded-[100px] flex justify-center items-center gap-[2px] bg-white border border-senate',
        className,
        {
          'bg-disabled': disabled,
        },
      )}
      disabled={disabled}
      {...rest}
    >
      <Icon type="arrow-round" />
      {children}
    </button>
  );
}

export default View3D;
